import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import ButtonComponent from '../../../components/ButtonComponent';
import { Add } from '@mui/icons-material';
import React, { useContext, useEffect, useState } from 'react';
import LprGroupEditionModal from './LprGroupEditionModal';
import {
  useDeleteLprGroupAsync,
  useGetAllLprGroupByLicenseAsync,
  useGetLprGroupByIdAsync,
} from '../../../services/LprGroupService/hooks/useMutation';
import {
  ILprGroupProps,
  ILprGroupSimpleProps,
} from '../../../services/LprGroupService/types';
import ButtonActionsComponent from '../../../components/ButtonActionsComponent';
import { AppContext } from '../../../context/AppContextProvider';
import ConfirmDeleteModalComponent from '../../../components/ConfirmDeleteModalComponent';

const LprGroupManagement = () => {
  const [isVisibleEditionModal, setIsVisibleEditionModal] = useState(false);
  const { showSnackbar } = useContext(AppContext);
  const [groups, setGroups] = useState<ILprGroupSimpleProps[]>([]);
  const [selectedLprGroup, setSelectedLprGroup] = useState<
    ILprGroupProps | undefined
  >(undefined);
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState(false);
  const [selectedItemToDelete, setSelectedItemToDelete] =
    useState<ILprGroupSimpleProps>();
  const {
    mutateAsync: mutateGetAllLprGroupByLicenseAsync,
    isLoading: isLoadingGetAllLprGroupByLicenseAsync,
  } = useGetAllLprGroupByLicenseAsync();
  const { mutateAsync: mutateGetLprGroupByIdAsync } = useGetLprGroupByIdAsync();
  const {
    mutateAsync: mutateDeleteLprGroupAsync,
    isLoading: isLoadingDeleteLprGroupAsync,
  } = useDeleteLprGroupAsync();

  const additionalButtons = (
    <ButtonComponent
      startIcon={<Add />}
      size="small"
      onClick={() => setIsVisibleEditionModal(true)}
    >
      Novo grupo
    </ButtonComponent>
  );

  const columns: IColumnProps[] = [
    {
      label: 'Nome',
      id: 'name',
    },
    {
      label: 'Notificações',
      id: 'isSendAllEvents',
      width: 0,
      render(notifications) {
        return <>{notifications ? 'ATIVADAS' : 'DESATIVADAS'}</>;
      },
    },
    {
      id: 'id',
      label: 'Ações',
      align: 'center',
      width: 0,
      render: (id) => (
        <ButtonActionsComponent
          key={id}
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  const handleCancelDeletion = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItemToDelete(undefined);
  };

  const handleDeleteItem = async (id: number) => {
    const gp: any = groups.find((g) => g.id === id);
    if (gp == null) return;
    setSelectedItemToDelete(gp);
    setIsVisibleDeleteItemModal(true);
  };

  const handleConfirmDeletion = () => {
    if (selectedItemToDelete?.id)
      mutateDeleteLprGroupAsync(selectedItemToDelete?.id).then(() => {
        setIsVisibleDeleteItemModal(false);
        showSnackbar('Grupo excluído com sucesso.', 'success');
        getAllGroups();
      });
  };

  const handleEdit = (id: number) => {
    mutateGetLprGroupByIdAsync(id).then(setSelectedLprGroup);
    setIsVisibleEditionModal(true);
  };

  const getAllGroups = () => {
    mutateGetAllLprGroupByLicenseAsync().then(setGroups);
  };

  useEffect(() => {
    getAllGroups();
  }, []);

  return (
    <>
      <TableComponent
        rows={groups}
        isLoading={isLoadingGetAllLprGroupByLicenseAsync}
        title="Grupos"
        columns={columns}
        emptyMessage={'Nenhum grupo encontrado.'}
        additionalTitleComponent={additionalButtons}
      />

      <LprGroupEditionModal
        isOpen={isVisibleEditionModal}
        onClose={() => {
          setSelectedLprGroup(undefined);
          setIsVisibleEditionModal(false);
          getAllGroups();
        }}
        selectedGroupToEdit={selectedLprGroup}
      />

      <ConfirmDeleteModalComponent
        isLoading={isLoadingDeleteLprGroupAsync}
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir Grupo LPR'}
        message={`Tem certeza que deseja excluir o grupo "${selectedItemToDelete?.name}"?`}
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
      />
    </>
  );
};

export default LprGroupManagement;
